import { setParams, getParams } from './params.js';

/**
 * Display Pills of active filters in filters footer.
 * @param  {object}   block                the block.
 * @param  {object}   inputs               all of the filter inputs.
 * @param  {Function} getFilterableContent Fetch the content.
 */
export const setActiveFilters = (block, inputs, getFilterableContent) => {
	const contentContainer = block.querySelector('.em-filterable-content__listings');
	const filterFooter = block.querySelector('.em-filterable-content__footer');
	const activeContainer = block.querySelector('.em-filterable-content__active-filters');
	const checked = {};

	// Loop through the inputs and get the set values.
	inputs.forEach((e) => {
		const tax = e.getAttribute('data');

		// If is checked set the tax parameters.
		if (e.checked && e.value) {
			if (checked[tax] !== undefined) {
				checked[tax].push(e.value);
			} else {
				checked[tax] = [e.value];
			}
		}

		// If is search set the search parameter.
		if (e.classList.contains('filter-search') && e.value) {
			checked.search = e.value;
		}
	});

	// Check if "checked" object has values.
	if (Object.keys(checked).length > 0) {
		// Show filter footer.
		filterFooter.style.display = 'flex';

		// Output the pills!
		let html = '';
		Object.keys(checked).forEach((k) => {
			const values = checked[k];

			if (k === 'search') {
				const input = block.querySelector('[name="search"]');
				html += `<span data="search">${input.value}</span>`;
			} else {
				values.forEach((value) => {
					const input = block.querySelector(`[name="${k}_${value}"]`);
					html += `<span data="${k}_${value}">${input.dataset.name}</span>`;
				});
			}
		});
		activeContainer.innerHTML = html;

		// Get all the pills and assign onclick event handlers.
		const activeFilters = activeContainer.querySelectorAll('span');
		activeFilters.forEach((pill) => {
			pill.onclick = (e) => {
				const $this = e.target;
				const input = block.querySelector(`[name="${$this.getAttribute('data')}"]`);

				if (input.type === 'checkbox') {
					input.checked = false;
				} else {
					input.value = '';
				}

				setParams(block);

				// Reset the active filters.
				setActiveFilters(block, inputs);

				// Fetch the content.
				getFilterableContent(contentContainer, getParams(block));
			};
		});
	} else {
		// If "checked" object empty (no filters checked) hide the filter footer.
		filterFooter.style.display = 'none';
	}
};

/**
 * Clear All Filters.
 * @param  {[type]} block [description]
 * @return {[type]}       [description]
 */
export const clearFilters = (block, inputs, getFilterableContent) => {
	const contentContainer = block.querySelector('.em-filterable-content__listings');
	const clear = block.querySelector('.em-filterable-content__clear-filters button');
	const filterFooter = block.querySelector('.em-filterable-content__footer');

	// Onclick remove all filters and refetch the content.
	clear.onclick = () => {
		// Hide the filter footer.
		filterFooter.style.display = 'none';
		inputs.forEach((e) => {
			if (e.checked) {
				e.checked = false;
			}

			// If is search set the search parameter.
			if (e.classList.contains('filter-search')) {
				e.value = '';
			}
		});

		setParams(block);

		// Fetch the content.
		getFilterableContent(contentContainer, getParams(block));
	};
};
